import React from 'react'
import Bano from '../components/Hospital/Bano'
import Ho from '../components/Hospital/Ho'
import Gallery from '../components/Hospital/Gallery'
import Trusted from '../components/Home/Trusted'
import Flex from '../components/Home/Flex'
import Form from '../components/Home/Form'

function Hospital() {
  return (
    <div>
<Bano/>
<Ho/>
<Gallery/>
<Trusted/>
<Flex/>
<Form/>
    </div>
  )
}

export default Hospital